/**
 * Simple progress counter for batch operations.
 * Replaces the old FinishedUploadsCounter class component.
 * Used by MoveItemModal, CopyItemModal, and FileUploadingModal.
 */
interface ProgressCounterProps {
  filesListLength: number;
  finishedUploadsListLength: number;
  failedUploadsListLength: number;
  fileUploadingProcessStatus?: string;
}

export function FinishedUploadsCounter({
  filesListLength,
  finishedUploadsListLength,
  failedUploadsListLength,
}: ProgressCounterProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <span className="font-medium">{finishedUploadsListLength} / {filesListLength}</span>
      {failedUploadsListLength > 0 && (
        <span className="font-medium text-destructive">({failedUploadsListLength} failed)</span>
      )}
    </div>
  );
}
